<div class="mb-4">
  The following pays for {{ personName }} are available to void from payroll history
</div>
<div style="max-height: 400px; overflow: auto">
  <div
    *ngFor="let sel of selections; let i = index"
    class="border-bottom border-light border-2 d-flex py-2 gap-5">
    <div>
      <input
        type="radio"
        class="small"
        id="{{ 'history-void-payroll' + i }}"
        [value]="selections[i]"
        [(ngModel)]="selPayroll"
        data-testid="selHistoryVoidPaylineOpt" />
      <label class="fw-bold mb-0" for="{{ 'history-void-payroll' + i }}"
        ><span></span> Paydate {{ sel.PayDate }}
      </label>
    </div>
    <div class="cursor-pointer" (click)="selPayroll = selections[i]" style="width: 65px">
      Ref: {{ sel.Payroll.SequenceNumber }}
    </div>
    <div class="cursor-pointer" (click)="selPayroll = selections[i]">
      {{ checkNumberDisplay(sel.Payline.OverrideCheckNumber) }}
    </div>
  </div>
</div>
<div class="d-flex mt-2 justify-content-end">
  <button class="btn btn-secondary" (click)="onBack()">Back</button>
  <button class="btn btn-primary ms-3" (click)="onContinue()" [disabled]="!selPayroll">
    Confirm & Continue
  </button>
</div>
